import { WrenchIcon } from 'lucide-react';
import { ProductDocument, ProductTemplate } from 'models/product';

type UniversalFitmentNoticeProps = {
  product: ProductTemplate | ProductDocument;
  compact?: boolean;
};

export default function UniversalFitmentNotice({
  product,
  compact,
}: UniversalFitmentNoticeProps) {
  const rideTypes = (product as ProductDocument).ride_types ?? [];
  const rideTypeLabel = rideTypes.length ? rideTypes.join(', ') : null;

  const icon = (
    <div
      className={`flex shrink-0 items-center justify-center rounded-full bg-brand-secondary ${
        compact ? 'h-[3.5rem] w-[3.5rem]' : 'h-[4rem] w-[4rem]'
      }`}
    >
      <WrenchIcon
        className={compact ? 'h-[1.9rem] w-[1.9rem]' : 'h-[2.2rem] w-[2.2rem]'}
        color="#FFFFFF"
      />
    </div>
  );

  const heading = (
    <span
      className={`font-semibold text-black ${
        compact ? 'text-[1.8rem]' : 'text-[2rem]'
      }`}
    >
      Fitment Notes &amp; Exceptions
    </span>
  );

  const body = (
    <p className="text-[1.6rem] font-medium leading-snug text-zinc-600">
      This is a universal fit part. It is listed to fit most vehicles, but may
      or may not fit without modification — confirm compatibility with the
      seller before purchasing.
    </p>
  );

  if (compact) {
    return (
      <div className="-mt-8 mb-0 sm:mb-2 sm:mt-0 sm:p-4">
        <div className="flex w-full items-start gap-x-6 rounded-[2rem] border border-zinc-200 bg-zinc-100 p-[2rem]">
          {icon}

          <div className="flex flex-col gap-y-2">
            {heading}
            {body}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-full items-start gap-x-6 rounded-[1rem] border border-zinc-200 border-t-brand-secondary bg-white p-8 [border-top-width:0.375rem]">
      {icon}

      <div className="flex flex-col gap-y-3">
        {heading}
        {body}

        {rideTypeLabel && (
          <span className="text-[1.4rem] font-medium text-zinc-500">
            Intended for {rideTypeLabel}
          </span>
        )}
      </div>
    </div>
  );
}
